import React, { useState } from "react";
import stylesDefault from "../../SiteManagement/styles"; //TODO export these further up!
import {
  Button,
  Container,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import DeleteModal from "../Common/DeleteModal";
import { ProviderSiteDTO } from "@beable/roster-backend-client-v1";
import { SUBPAGES } from "../constants";
import AddProviderSiteModal from "./AddProviderSiteModal";
import EditProviderSiteModal from "./EditProviderSiteModal";

const getStyles = stylesDefault.pageStyles;

interface SSOProviderSiteActionsProps {
  selectedItem?: ProviderSiteDTO;
  onActionComplete: (success: boolean) => void;
}

export default function SSOProviderSiteActions({
  selectedItem,
  onActionComplete,
}: SSOProviderSiteActionsProps) {
  const theme = useTheme();
  const styles = getStyles(theme);

  const [displayModal, setDisplayModal] = useState<
    "add" | "edit" | "delete" | undefined
  >();

  const closeModal = (success: boolean) => {
    setDisplayModal(undefined);
    onActionComplete(success);
  };

  const formatText = (item: ProviderSiteDTO) => {
    const referenceItem = item.provider;
    if (!referenceItem) {
      return "unkown";
    }

    let label = referenceItem?.name;
    if (referenceItem.environment) label += ` (${referenceItem.environment})`;
    return label.length ? label : "unknown";
  };

  return <>
    <Container sx={styles.dfb}>
      <Button
        sx={styles.verticalBtn}
        variant="contained"
        color="primary"
        onClick={() => setDisplayModal("add")}
      >
        Add new site
      </Button>
    </Container>
    {selectedItem?.id ? (
      <>
        <Typography variant="h5" sx={{ margin: "16px" }}>
          Options for {formatText(selectedItem)}
        </Typography>
        <Container sx={styles.dfb}>
          <Button
            sx={styles.verticalBtn}
            variant="contained"
            color="secondary"
            onClick={() => setDisplayModal("edit")}
          >
            Edit
          </Button>
          <Button
            sx={[styles.verticalBtn, styles.plainBtn]}
            variant="contained"
            onClick={() => setDisplayModal("delete")}>
            Delete
          </Button>
        </Container>
      </>
    ) : undefined}
    <AddProviderSiteModal
      open={displayModal === "add"}
      handleClose={closeModal}
    />
    {selectedItem ? (
      <>
        <EditProviderSiteModal
          open={displayModal === "edit"}
          handleClose={closeModal}
          siteItem={selectedItem}
        />
        <DeleteModal
          open={displayModal === "delete"}
          handleClose={closeModal}
          subpage={SUBPAGES.providerSites.value}
          item={selectedItem}
          name={selectedItem.provider?.name}
        />
      </>
    ) : undefined}
  </>;
}